// components/ui/section-heading.jsx
import React from 'react';
import { cn } from '@/lib/utils';

/**
 * SectionHeading
 * - Renders title/description only if provided
 * - Optional eyebrow + actions
 * - Align: left | center
 */
export default function SectionHeading({
    eyebrow,
    title,
    description,
    align = 'left', // "left" | "center"
    actions,
    className,
    titleClassName,
    descriptionClassName,
}) {
    // If nothing passed, render nothing
    if (!eyebrow && !title && !description && !actions) return null;

    const isCenter = align === 'center';

    return (
        <div
            className={cn(
                'space-y-2',
                isCenter ? 'text-center items-center' : 'text-left',
                className
            )}
        >
            {eyebrow ? (
                <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
                    {eyebrow}
                </p>
            ) : null}

            <div
                className={cn(
                    'flex flex-col gap-3',
                    actions ? 'sm:flex-row sm:items-end sm:justify-between' : ''
                )}
            >
                <div className={cn(isCenter ? 'mx-auto' : '')}>
                    {title ? (
                        <h2
                            className={cn(
                                'fs-66 font-semibold tracking-tight sm:text-3xl mb-6',
                                titleClassName
                            )}
                        >
                            {title}
                        </h2>
                    ) : null}

                    {description ? (
                        <p
                            className={cn(
                                'max-w-4xl text-foreground/80',
                                isCenter ? 'mx-auto' : '',
                                descriptionClassName
                            )}
                        >
                            {description}
                        </p>
                    ) : null}
                </div>

                {actions ? <div className={cn(isCenter ? 'mx-auto' : '')}>{actions}</div> : null}
            </div>
        </div>
    );
}
